import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideMarkdown } from 'ngx-markdown';
import { jwtInterceptor } from './interceptors/jwt.interceptor';
import { getRuntimeConfig } from './runtime-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr(), withInterceptors([jwtInterceptor])),
    provideAnimations(),
    provideMarkdown(),
    { provide: 'environment', useFactory: getRuntimeConfig }
  ]
};
